import { all } from 'redux-saga/effects';
import orgSaga from './organizations/orgSaga';
import participantsSaga from './participants/participantsSaga';
import pdfDataExtractionSaga from './pdfDataExtraction/pdfDataExtractionSaga';
import subscriptionSaga from './subscription/subscriptionSaga';
import userSaga from './user/userSaga';

export default function* rootSaga() {
  yield all([userSaga(), orgSaga(), subscriptionSaga(), participantsSaga(), pdfDataExtractionSaga()]);
}
